<template>
  <el-dialog title="問題回報" :visible="isOpen" :append-to-body="true" @close="handleClose" :boolean="false">
    <el-form :model="form" ref="form" :rules="rules">
      <div class="custom-modal-img" id="capture" name="screen_file"></div>
      <el-form-item label="回報類型" :label-width="formLabelWidth">
        <el-radio v-model="form.type" label="資料問題" name="type">資料問題</el-radio>
        <el-radio v-model="form.type" label="系統問題" name="type">系統問題</el-radio>
        <el-radio v-model="form.type" label="使用問題" name="type">使用問題</el-radio>
        <el-radio v-model="form.type" label="建議回饋" name="type">建議回饋</el-radio>
        <el-radio v-model="form.type" label="其他" name="type">其他</el-radio>
      </el-form-item>
      <el-form-item label="回報描述" :label-width="formLabelWidth" prop="content">
        <el-input type="textarea" :rows="5" placeholder="請輸入內容" v-model="form.content" name="content"></el-input>
      </el-form-item>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <!-- <el-button @click="isOpen = false">取 消</el-button> -->
      <el-button type="primary" @click="sentQuestionReport()">確 定</el-button>
    </div>
  </el-dialog>
</template>

<script>

  import html2canvas from 'html2canvas';
  import { mapGetters } from 'vuex'
  import axios from 'axios'

  export default {
    props: [
      'isOpen',
    ],
    components: {
      ...mapGetters([
      'account_info'
    ])
    },
    watch: {
      isOpen (val) {
        if(val === true){
          html2canvas(document.querySelector("#app section")).then(canvas => {
            let imageArea = document.querySelector('#capture')
            if(imageArea.hasChildNodes()){
              imageArea.removeChild(imageArea.childNodes[0])
            }
            imageArea.appendChild(canvas)
            let imageUrl = imageArea.childNodes[0].toDataURL()
            this.imageBase64 = imageArea.childNodes[0].toDataURL()
          });

          this.form.type = "資料問題"
          this.form.content = ""
        }
      },
    },
    data() {
      return {
        // dialogFormVisible: false,
        form: {
          type: '資料問題',
          content: '',
          email: '',
          screen_file: '',
        },
        formLabelWidth: '120px',
        imageBase64: '',
        rules: {
          content: [
            { required: true, message: '請輸入內容', trigger: 'blur' }
          ],
        }
      }
    },
    methods: {
      sentQuestionReport(){
        // 驗證
        this.$refs['form'].validate((valid) => {
          if (valid) {
            // 附檔
            let block = this.imageBase64.split(";");
            let contentType = block[0].split(":")[1];
            let realData = block[1].split(",")[1];
            let blob = this.b64toBlob(realData, contentType);
            this.form.screen_file = blob
            // 取得使用者mail
            this.form.email = this.account_info.email
      
            let data = new FormData();
            data.append("type" ,this.form.type);
            data.append("content" , this.form.content);
            data.append("email" , this.form.email);
            data.append("screen_file" , this.form.screen_file, "screenshot.jpg");
            
            
            axios({
              method: 'post',
              url: process.env.VUE_APP_API_BACKSTAGE_URL + '/issue-report/add',
              data: data,
              config: { headers: {'Content-Type': 'multipart/form-data' }}
              })
              .then((response) => {
                  //handle success
                  console.log(response);
                  if(response.status === 200){
                    this.notify_message(this.ERROR.LEVEL.SUCCESS, '問題回報已送出', "")
                    this.$emit('update:isOpen', false)
                  }
              })
              .catch((response) => {
                  //handle error
                  this.notify_message(this.ERROR.LEVEL.ERROR, '問題回報送出失敗', "")
                  console.log(response);
              });

          } else {
            this.notify_message(this.ERROR.LEVEL.ERROR, '請輸入回報描述', "")
            return false;
          }
        });
        
      },
      handleClose () {
        //this.isOpen = false
        this.$emit('update:isOpen', false)
      },
      b64toBlob(b64Data, contentType, sliceSize) {
        contentType = contentType || '';
        sliceSize = sliceSize || 512;

        var byteCharacters = atob(b64Data);
        var byteArrays = [];

        for (var offset = 0; offset < byteCharacters.length; offset += sliceSize) {
            var slice = byteCharacters.slice(offset, offset + sliceSize);

            var byteNumbers = new Array(slice.length);
            for (var i = 0; i < slice.length; i++) {
                byteNumbers[i] = slice.charCodeAt(i);
            }

            var byteArray = new Uint8Array(byteNumbers);

            byteArrays.push(byteArray);
        }

        var blob = new Blob(byteArrays, {type: contentType});
        return blob;
      }
    }
  };
</script>

<style lang="scss" scoped>
  /deep/.custom-modal-img {
    margin: 0 20px 10px;
    border: 1px solid #dcdfe6; 
    background-color: white; 
    height: auto; 
    width: auto;
    text-align: center; 
    overflow: hidden; 
    border-radius: 5px;
  }

  /deep/.custom-modal-img canvas{
    height: auto !important; 
    width: 100% !important; 
  }
</style>